import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CopydatasetDialogComponent } from 'src/app/user/report-configuration/copydataset-dialog/copydataset-dialog.component';

@Component({
    selector: 'app-dataset-action',
    template: `
    <button title="Edit Dataset" (click)="edit($event);" class="btn btn-primary btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;" [disabled]="!hasPermission(128)">
        <i class="fas fa-pencil-alt"></i>
    </button>
    <button title="Delete Dataset" (click)="delete($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920" [disabled]="!hasPermission(129)">
        <i class="far fa-trash-alt"></i>
    </button>
    <button title="Refresh Dataset" (click)="refreshDataset($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;background:#F4C430" [disabled]="!hasPermission(126)">
        <i class="fas fa-refresh"></i>
    </button>
    <button title="Dataset Permission"  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;background:#00cc66" 
    [appCriticalOperation]="131" [criticalMethod]="access_permission.bind(this)">
        <i class="	fas fa-user-shield"></i>
    </button>

    <button title="Analysis" (click)="redirecttoQuickSight($event);" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#00bcd4" [disabled]="!hasPermission(132)">
      <i class="fas fa-industry"></i>
    </button>
    <button title="Copy Dataset" (click)="copyDataset($event);" class="btn btn-primary btn-outline btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem;" [disabled]="!hasPermission(130)">
        <i class="fas fa-copy"></i>
    </button>`,
    standalone: false
})
export class DatasetActionButtons implements ICellRendererAngularComp {

    params;
    label: string;
    permissions: any[] = [];
    constructor(private dialog: MatDialog
    ){

    }

    agInit(params): void {
        this.params = params;
        this.label = this.params.label || null;
        this.permissions = this.params.values || [];
         console.log("Renderer Permissions:", this.permissions);
    }

    refresh(params?: any): boolean {
        this.permissions = params.values;
        return true;
    }

    edit($event) {
        if (this.params.edit instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.edit(params);

        }
    }

    delete($event) {
        if (this.params.delete instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.delete(params);

        }
    }
    
    refreshDataset($event) {
        if (this.params.refreshDataset instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.refreshDataset(params);

        }
    }


    access_permission($event){
        console.log($event)
        if (this.params.access instanceof Function) {
            // put anything into params u want pass into parents component
            const params = {
                event: $event,
                rowData: this.params.node.data
                // ...something
            }
            this.params.access(params);
        }
    }


    redirecttoQuickSight($event){
        console.log($event)
        if (this.params.redirecttoQuickSight instanceof Function) {
          // put anything into params u want pass into parents component
          const params = {
            event: $event,
            rowData: this.params.node.data
            // ...something
          }
          this.params.redirecttoQuickSight(params);
    
        }
      }

    //   copyDataset($event){
    //     console.log("Inside Dataset action buttons...");
    //     console.log($event)

    //     // let dialogRef = this.dialog.open(CopydatasetDialogComponent, {
    //     //     maxWidth: "100vw",
    //     //     height: "30%",
    //     //     width: "60%",
    //     //     data: { data: this.params},
    //     //     disableClose: true,
    //     //   });

    //     if(this.params.copyDataset instanceof Function){
    //         const params = {
    //             event : $event,
    //             rowData : this.params.node.data
    //         }
    //         this.params.copyDataset(params)
    //     }

    //   }

    copyDataset($event) {
        console.log("Inside Dataset action buttons...");
        console.log($event)

        // let dialogRef = this.dialog.open(CopydatasetDialogComponent, {
        //     maxWidth: "100vw",
        //     height: "30%",

        //     width: "40%",
        //     data: { data: this.params },
        //     disableClose: true,
        // });



        if(this.params.copyDatasetandupdate instanceof Function){

            const params = {
                event : $event,
                rowData : this.params.node.data
            }

            this.params.copyDatasetandupdate(this.params)
        }
    }


    
 hasPermission(buttonId: number): boolean {
    // Check if 'screen' exists in the permissions array
    const hasScreen = this.permissions.some(permission =>
        typeof permission === 'string' && permission.includes('screen')
    );
    // If 'screen' is not present, enable all buttons
    if (!hasScreen) {
        return true;
    }

    // Otherwise, check if the specific buttonId is in the permissions list
    return this.permissions.includes(buttonId);
   }


      

}
